var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":_vm.link,"target":"__blank"}},[_c('button',{staticClass:"btn"},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":_vm.fontAwesome}}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }